var _module_exports ="<div ng-if=\"ctxItem\"\n     grc-risk\n     box-tmpl=\"nav\" box-tmpl-behavior=\"ctxt\"\n     box-model=\"ctxItem\"\n     box-click=\"goToContext()\"></div>\n";;
var path = '/app/Main/grcEdit/risk/GOVHistoryCtxtDirective-riskEdit.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;